import { Component } from "@angular/core";
import {
  Platform,
  NavParams,
  ViewController,
  LoadingController,
  AlertController,
  DateTime
} from "ionic-angular";
import { SummaryServiceProvider } from "../../../../providers/wh/summary-service";

@Component({
  selector: "hold-rto-modal",
  templateUrl: "hold-rto-modal.html",
  providers: [SummaryServiceProvider]
})
export class HoldRtoModalComponent {
  data;
  expireTime: any;
  isUpdate: any;

  constructor(
    public platform: Platform,
    public params: NavParams,
    public loadingCtrl: LoadingController,
    public summaryService: SummaryServiceProvider,
    private alertCtrl: AlertController,
    public viewCtrl: ViewController
  ) {
    this.data = this.params.get("data");
    this.isUpdate = this.params.get("update");
    let date = new Date();
    let tzoffset = new Date().getTimezoneOffset() * 60000; //offset in milliseconds
    let formattedDate = new Date(Date.now() - tzoffset)
      .toISOString()
      .split(".")[0]
      .toString();
    this.expireTime = formattedDate;
    if (this.isUpdate) {
      this.data = {
        id: this.data.id,
        awb: this.data.waybillOrderEntity.awb,
        orderNo: this.data.orderNo,
        clientName: this.data.waybillOrderEntity.ecommerceEntity.name,
        clientPickupTime: this.data.waybillOrderEntity.pickupFromClientTime,
        siteId: this.data.waybillOrderEntity.collectionPointEntity.siteId
      };
    } else {
      if (this.data.pickupFromClientTime.slice(-1) == "Z") {
        this.data.pickupFromClientTime = this.data.pickupFromClientTime.slice(
          0,
          -1
        );
      }
      this.data = {
        awb: this.data.awb,
        orderNo: this.data.orderNo,
        clientName: this.data.ecommerceEntity.name,
        clientPickupTime: this.data.pickupFromClientTime,
        siteId: this.data.collectionPointEntity.siteId
      };
    }
    //this.data = this.params;
  }

  confirmRtoHolding() {
    //1158879279
    var message = "Do you want to hold this Parcel";
    let alert = this.alertCtrl.create({
      title: "Confirm",
      message: `${message}`,
      buttons: [
        {
          text: "No",
          role: "cancel",
          handler: () => {
            console.log("Cancel clicked");
          }
        },
        {
          text: "Yes",
          handler: () => {
            var payload = {
              orderNo: this.data.orderNo,
              active: "YES",
              expiredTime: this.expireTime
            };
            if (this.isUpdate) {
              this.summaryService
                .updateHoldRto(this.data.id, payload)
                .then(res => {
                  this.viewCtrl.dismiss(true);
                });
            } else {
              this.summaryService.createHoldRto(payload).then(res => {
                this.viewCtrl.dismiss(true);
              });
            }
          }
        }
      ]
    });
    alert.present();
  }

  dismiss() {
    this.viewCtrl.dismiss();
  }
}



// WEBPACK FOOTER //
// ./src/pages/qdb/search-parcel/hold-rto-modal/hold-rto-modal.ts